import React, {Fragment} from 'react';
import Box from '../layout/Box';
import createEditor from '../form/ComponentEditor';
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import {SelectButton} from "primereact/selectbutton";
import {CurrencyFormatter, ProductColumn, productTooltip, UnitFormatter} from "../../utils/formatters";
import BoxEditor from "./BoxEditor";

export class stockEditor extends React.Component {

    state = {
        filter: ["store"]
    };

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const sortable = true;
        const filterable = true;
        let columns = [];
        let filters = [];
        let filter = [];
        if (this.props.product_id === undefined) {
            filters = [
                {label: 'Raktáranként', value: "store", filter: {field: "store", operator: "not isnull"}}
            ];
            columns = {
                "base_product_id": {
                    header: 'Árukód',
                    width: 1,
                    sortable,
                    filterable
                },
                "displayname": {
                    ...ProductColumn("product_id"),
                    width: 3,
                },
                "category.name": {
                    header: 'Árutípus',
                    width: 1,
                    sortable,
                    filterable
                },
                "tradename.name": {
                    header: 'Kiadó',
                    width: 1,
                    sortable,
                    filterable
                },
                "sku": {
                    header: 'ISBN',
                    width: 1,
                    sortable,
                    filterable
                },
                "barcode": {
                    header: 'Vonalkód',
                    width: 1,
                    sortable,
                    filterable
                },
                "listprice": {
                    header: 'Listaár',
                    width: 1,
                    sortable,
                    filterable,
                    className: "currency",
                    renderer: CurrencyFormatter
                },
                "qty": {
                    header: 'Darabszám',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                    className: "unit"
                },
                "shadowqty": {
                    header: '- Hiány/ + Többlet',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                    className: "unit"
                },
                "partner.name": {
                    header: 'Partner',
                    width: 2,
                    sortable,
                    filterable
                },
                "store.name": {
                    header: 'Raktár',
                    width: 2,
                    sortable,
                    filterable
                },
                /*"authors": {header: 'Szerzők', width: 1, renderer: (authors) => {
                    return authors.map((author) => author.name).reduce((prev, curr) => [prev, prev ? ', ' : '', curr], null)
                }}*/
                ...(this.props.plusColumns || {})
            };
            filter = filters.filter((item) => this.state.filter.indexOf(item.value) !== -1).map((item) => item.filter);
            if (!filter.length) {
                filter = [{field: "partner", operator: "not isnull"}];
                delete columns["store.name"];
            }
            if (this.props.store_id && this.props.store_id.length) {
                filter = [
                    ...filter,
                    Array.isArray(this.props.store_id)
                        ?
                        {
                            field: "store",
                            value: this.props.store_id.map(store => store.id),
                            operator: "in"
                        }
                        :
                        {
                            field: "store",
                            value: this.props.store_id,
                            operator: "="
                        }
                ];
            }
        } else {
            columns = {
                //"id": {width: 1, sortable, filterable},
                "displayname": {
                    header: 'Név',
                    width: 3,
                    sortable,
                    filterable,
                    tooltip: productTooltip("product_id")
                },
                "category.name": {
                    header: 'Árutípus',
                    width: 1,
                    sortable,
                    filterable
                },
                "tradename.name": {
                    header: 'Kiadó',
                    width: 1,
                    sortable,
                    filterable
                },
                "sku": {
                    header: 'ISBN',
                    width: 2,
                    sortable,
                    filterable
                },
                "barcode": {
                    header: 'Vonalkód',
                    width: 2,
                    sortable,
                    filterable
                },
                "listprice": {
                    header: 'Listaár',
                    width: 2,
                    sortable,
                    filterable,
                    className: "currency",
                    renderer: CurrencyFormatter
                },
                "qty": {
                    header: 'Darabszám',
                    width: 2,
                    sortable,
                    filterable,
                    renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                    className: "unit"
                },
                "store.name": {
                    header: 'Raktár',
                    width: 2,
                    sortable,
                    filterable
                },
                /*"authors": {header: 'Szerzők', width: 1, renderer: (authors) => {
                    return authors.map((author) => author.name).reduce((prev, curr) => [prev, prev ? ', ' : '', curr], null)
                }}*/
                ...(this.props.plusColumns || {})
            };
            filter = [
                {field: "store", operator: "not isnull"},
            ];
            if (this.props.store_id) {
                filter = [...filter, {field: "store", value: this.props.store_id, operator: "!="}];
            }
        }
        if (this.props.product_id) {
            filter.push({field: "id", value: this.props.product_id});
        }
        if (this.props.partner_id) {
            filter.push({field: "partner", value: this.props.partner_id, operator: Array.isArray(this.props.partner_id) ? "in" : "="});
        }
        filter = [...filter, {field: "qty", value: 0, operator: "!="}];
        return (
            <Fragment>
                <List
                    theme="default"
                    header={"Készlet lista"}
                    actions={this.props.product_id === undefined && <SelectButton value={this.state.filter} multiple={true} options={filters} onChange={(e) => this.setState({filter: e.value})} />}
                >
                    <SelectorGrid
                        gridid={this.props.gridid !== undefined ? this.props.gridid : "stockList"}
                        loading={this.props.isLoading}
                        componentConfig={this.props.componentConfig}
                        view={[...Object.keys(columns), "product_id", "store.id", "partner.partner_id"]}
                        exports={[
                            {as: "excel", label: "Excel", icon: "far fa-file-excel", addFilters: true, browserExport: {type: "excel", filename: "készlet.xlsx", order: {field: "store", direction: "ASC"}}},
                            {as: "excel", label: "Megrendeléshez", icon: "far fa-file-excel", view: ["displayname", "barcode", "listprice"], labels: {displayname: "Cím", barcode: "Vonalkód", listprice: "Fogyasztói ár"}, addFilters: true, browserExport: {type: "excel", filename: "pagony_megrendeles.xlsx", order: {field: "store", direction: "ASC"}}}
                        ]}
                        aggregations={{
                            fields: {
                                "qty": {
                                    field: "qty", type: "SUM"
                                }
                            }
                        }}
                        columns={columns}
                        filter={filter}
                        pageSize={50}
                        actions={true}
                        // kell az id mivel nincs idfield...
                        orderBy={{field: "id", direction: "DESC"}}
                    />
                </List>
            </Fragment>
        );
    }
}
export default createEditor({componentName: "StockItem", WrappedComponent: stockEditor, editor: "stock"});

